export default function Customize() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_10137_34671)">
                <path
                    d="M15.2269 5.15486C17.3374 7.26538 17.3374 10.6872 15.2269 12.7978C14.5815 13.4432 13.8134 13.8912 12.9977 14.1419V20.3463L12.9977 27.8841L9.81321 27.8841V14.1419C8.99752 13.8912 8.22944 13.4432 7.58403 12.7978C5.4735 10.6872 5.47351 7.26538 7.58403 5.15486C8.22944 4.50945 8.9975 4.0614 9.8132 3.81073L9.81321 8.65786L12.9977 8.65786L12.9977 3.81073C13.8134 4.06142 14.5815 4.50945 15.2269 5.15486Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20 16.6667C20 16.2985 20.2985 16 20.6667 16H24.6667C25.0349 16 25.3333 16.2985 25.3333 16.6667V27.3333C25.3333 27.7015 25.0349 28 24.6667 28H20.6667C20.2985 28 20 27.7015 20 27.3333V16.6667Z"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <path
                    d="M21.0667 8.8V16H24.2667V8.8L25.3333 7.2L24.2667 4H21.0667L20 7.2L21.0667 8.8Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_10137_34671">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
